import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { initSentry } from "@/lib/sentry";
import "@/styles/globals.css";

// Fire-and-forget: we don't want SDK boot to block first paint, and
// `initSentry()` is a no-op when VITE_SENTRY_DSN is empty.
void initSentry();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
